<template>
  <div class="comboTab">
    <div
      v-if="combosData.length <= 0"
      class="noData"
      style="height:400px; text-align:center;line-height:300px"
    >
      暂无数据
    </div>
    <ul class="list" v-else>
      <template v-for="i in combosData">
        <li :key="i.id">
          <div
            class="top display-flex align-items-center justify-content-space-between"
          >
            <h6>{{ i.name }}</h6>
            <p :class="{ active: i.examPassed == 1 }">
              {{ i.examPassed == 1 ? "已通过考试" : "未通过考试" }}
            </p>
          </div>
          <div
            class="bottom display-flex align-items-center justify-content-space-between"
          >
            <div class="progress">
              <div class="zy" v-if="i.zytime">
                <div class="display-flex">
                  <span class="label">专业课学时</span>
                  <div class="proLength">
                    <Progress
                      status="active"
                      :percent="i.zyProgress"
                      :stroke-color="['#31AF58', '#31AF58']"
                      :stroke-width="10"
                      hide-info
                    ></Progress>
                  </div>
                  <span class="p1 p">
                    <i>{{ i.zytimeNow | decimal }}/</i>
                    {{ i.zytime | decimal }}
                  </span>
                </div>
              </div>
              <div class="gx" v-if="i.gxtime">
                <div class="display-flex">
                  <span class="label">公需课学时</span>
                  <div class="proLength">
                    <Progress
                      status="active"
                      :percent="i.gxProgress"
                      :stroke-color="['#EC6941', '#EC6941']"
                      :stroke-width="10"
                      hide-info
                    ></Progress>
                  </div>
                  <span class="p2 p">
                    <i>{{ i.gxtimeNow | decimal }}/</i>
                    {{ i.gxtime | decimal }}
                  </span>
                </div>
              </div>
            </div>
            <div class="buttonGroup">
              <Button
                type="success"
                class="btn1 btn"
                @click="handleTest(i)"
                :class="{ buttonActive: i.isStudyAll && i.examTimesLeft > 0 }"
              >
                <p>
                  参加考试
                  <!-- <span>剩余{{ i.examTimesLeft }}次</span> -->
                </p>
              </Button>
            </div>
          </div>
        </li>
      </template>
    </ul>
    <div class="page"></div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { postData, showLoading } from "../../assets/api/api.js";
export default {
  name: "comboTab",
  props: ["state"],
  components: {},
  data() {
    return {};
  },
  created() {
    this.loadData();
  },
  filters: {
    decimal(val) {
      return Number(val).toFixed(2);
    },
  },
  mounted() {},
  computed: {
    ...mapState(["combosData"]),
  },
  methods: {
    ...mapActions(["getCombosData"]),
    handleTest(i) {
      if (!i.isStudyAll) {
        this.$Message.warning("完成所需学时才能参加考试");
        return;
      }
      if (i.examTimesLeft == 0) {
        this.$Message.warning("已经没有考试机会");
        return;
      }
      this.$router.push({
          path: "/ExaminationInfo",
          query: { cid: i.cid, orderId: i.oid, id: i.id },
        });
      // if (i.examTimes <= 0) {
      //   this.$router.push({
      //     path: "/ExaminationIdentity",
      //     query: { cid: i.cid, orderId: i.oid, id: i.id },
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/ExaminationInfo",
      //     query: { cid: i.cid, orderId: i.oid, id: i.id },
      //   });
      // }
    },
    loadData() {
      var params = {
        state: this.state == "all" ? "" : this.state,
      };
      this.getCombosData(params);
     
    },
  },
};
</script>
<style></style>
<style lang="scss" scoped>
.comboTab {
  padding-left: 30px;
  padding-right: 30px;
  .list {
    height: 500px;
    overflow-y: auto;
  }
  li {
    border: 1px solid #f0f1f4;
    margin-bottom: 10px;
    .top {
      background: #fafafa;
      line-height: 30px;
      border-bottom: 1px solid #f0f1f4;
      padding-left: 20px;
      padding-right: 20px;
      .passed {
        color: #31af58;
      }
      .noPass {
        color: #ec6941;
      }
    }
    .bottom {
      .buttonGroup {
        .btn {
          width: 100px;
          height: 48px;
          border-radius: 0px;
          border: none;
        }
        .btn1 {
          margin-left: 10px;
          background: #cccccc;

          p {
            font-size: 14px;
          }
          span {
            display: block;
            font-size: 12px;
          }
        }
        .btn2 {
          line-height: 48px;
          background: rgba(57, 194, 134, 1);
          font-size: 14px;
        }
        .btn3 {
          margin-left: 10px;
          line-height: 48px;
          border: 1px solid rgba(102, 102, 102, 1);
          border-radius: 3px;
          background: #222222;
          color: #fff;
        }
        .buttonActive {
          background: rgba(49, 175, 88, 1);
        }
      }
      .progress {
        padding-left: 50px;
        .label {
          font-size: 14px;
          color: rgba(153, 153, 153, 1);
          margin-right: 10px;
        }
        .p {
          font-size: 14px;
          color: #222;
          margin-left: 10px;
        }
        .p1 i {
          color: #37bc5f;
        }
        .p2 i {
          color: #ec6941;
        }
        .proLength {
          width: 490px;
        }
      }
    }
  }
}
</style>
